import { Controller } from "@hotwired/stimulus"
import React from 'react';
import {createRoot} from 'react-dom/client';
import FileInput from '../components/FileInput';

// A component that provides a stylized file input and displays a preview
// of the selected file. A `data-image-file-input-name-value="name"` prop should be provided in
// order to set the name prop on the input for file submission.

// Connects to data-controller="file-input"
export default class extends Controller {
  static values = {inputName: String, inputAccepts: String, maxHeight: Number, ref: String, filename: String}

  connect() {
    const root = createRoot(this.element);
    root.render(<FileInput inputName={this.inputNameValue} inputAccepts={this.inputAcceptsValue} maxHeight={this.maxHeightValue} fileRef={this.refValue} file={this.filenameValue}/>);
  }
}

